/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import ValueOutcomes from '@/cmp/organism/ValueOutcomes/ValueOutcomes'
import CaseStudies from '@/templates/TalentMarketplace/components/CaseStudies/CaseStudies'
import ContentTypeFeatures from '../../organism/ContentTypeFeatures/ContentTypeFeatures'
import Benefits from '@/cmp/organism/Benefits/Benefits'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import { NewIndustryPageAttributes } from '@/utils/queries/industries'

/* styles */
import styles from './_.module.css'

interface Props {
  data: NewIndustryPageAttributes
}

function Industries({ data }: Props): JSX.Element {
  return (
    <>
      <PageHero
        layout="left"
        primaryHeadline={data.hero.title}
        heroTitleTag={data.heroTitleTag}
        subText={data.hero.description}
        image={data.hero.image?.data?.attributes}
        primaryCta={data.hero.primaryCta}
        secondaryCta={data.hero.secondaryCta}
        footNote={data.hero.footnote}
      />

      {data.brands.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brands.title}
          brands={data.brands.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      {data.goalList.length > 0 ? (
        <ValueOutcomes
          layout="descriptive"
          theme="dark"
          title={data.goalTitle}
          class={styles.valueOutcome}
          list={data.goalList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      <section className="font-heading text-white bg-blue-web-90">
        <CaseStudies
          title={data.caseStudyTitle}
          class={styles.caseStudy}
          caseStudies={data.caseStudyLists.data.map(item => ({
            slug: item.attributes.slug,
            customerLogoWhite:
              item.attributes.customerLogoWhite.data.attributes,
            caseStudySquareCardBgImage:
              item.attributes.caseStudySquareCardBgImage.data.attributes,
            statisticsList: item.attributes.statisticsList
          }))}
        />
      </section>

      {data.contentTypeFeatureList.length > 0 ? (
        <ContentTypeFeatures
          title={data.contentTypeFeatureTitle}
          list={data.contentTypeFeatureList.map(i => ({
            id: i.id,
            link: i.link,
            bgColor: i.color,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            tag: i.additionalFields?.tag as string | null,
            color: i.additionalFields?.color as string | null
          }))}
        />
      ) : null}

      {data.benefitList.length > 0 ? (
        <Benefits
          theme="purple"
          title={data.benefitTitle}
          list={data.benefitList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            image: i.multimedia?.media?.data?.attributes,
            description: i.description ?? ''
          }))}
        />
      ) : null}

      {/* TODO: This section will be added after the assets are ready */}
      {/* {servicesWithThumbnail.length > 0 ? (
        <ContentTypes
          title={data.contentTypeTitle}
          description={data.contentTypeDescription}
          servicesList={servicesWithThumbnail.map(i => ({
            slug: i.slug,
            pageTitle: i.pageTitle,
            type: i.type,
            thumbnailImg: i.thumbnailImg
          }))}
        />
      ) : null} */}

      {data.footerCta ? (
        <FooterCta
          headline={data.footerCta.title}
          mode="full_width"
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
        />
      ) : null}
    </>
  )
}

export default Industries
